import { BaseDto } from '../base.dto';
import { InspectionStandard } from './inspection-standard.dto';

export class InspectionField extends BaseDto {
  name?: string;
  isDefault?: boolean;
  inspectionStandards?: InspectionStandard[];
}
